import marmoset from './marmoset';

let self;
export default self = {
  /**
   * @async
   * @param {string} marmosetUrl
   * @returns {Image}
   */
  createThumbnail(marmosetUrl) {
    return new Promise((resolve, reject) => {
      marmoset.fetchThumbnail(marmosetUrl, resolve, err => {
        console.log('Failed to create marmoset thumb:', err);
        reject(err);
      });
    });
  },

  /**
   * @async
   * @param {string} marmosetUrl
   * @returns {Blob}
   */
  async createThumbnailBlob(marmosetUrl) {
    const img = await self.createThumbnail(marmosetUrl);

    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);

    return new Promise(resolve => {
      const quality = 1.0;
      canvas.toBlob(resolve, 'image/png', quality);
    });
  },
};



// WEBPACK FOOTER //
// ./src/packages/marmoset/index.js